class RelatedListFieldController {

    $onInit() {
        this.showError = false;
        this.errorMessage = '';
    }

    getItemIds() {
        return this.itemList.filter((i) => i.isRemoved !== true).map((i) => i.id);
    }

    hideError() {
        this.showError = false;
        this.errorMessage = '';
    }

    showErrorMessage(message) {
        this.showError = true;
        this.errorMessage = message;
    }

    /***
     * Adds a new item to the list of selected objects.
     *
     * @param item      a single object instance of the items passed in via the itemList property
     */
    addItem(item) {
        let itemIds = this.getItemIds();
        if (itemIds.indexOf(item.id) === -1) {
            itemIds.push(item.id);
            this.updateItemList({item: item, itemIds: itemIds}).then(
                    (successResponse) => {
                        const itemInList = this.itemList.filter((i) => i.id === item.id);
                        if (itemInList.length > 0) {
                            itemInList.map((i) => i.isRemoved = false);
                        }
                        else {
                            this.itemList.push(item);
                        }
                        this.hideError();
            }, (errorResponse) => {
                    this.showErrorMessage('There was an error trying to add this item. If this problem persists, ' +
                        'please contact a site administrator.');
            });
        }
    }

    /***
     * A callback function for when the delete or re-add button is clicked for an item. Triggers the callback function
     * provided to the component and then toggles the isRemoved property of the item that was toggled.
     *
     * @param item      a single object instance of the items passed in via the itemList property
     */
    toggleItem(item) {
        let itemIds = this.getItemIds();
        const itemIdIndex = itemIds.indexOf(item.id);
        if (itemIdIndex > -1) {
            itemIds.splice(itemIdIndex, 1);
        }
        else {
            itemIds.push(item.id);
        }
        this.updateItemList({item: item, itemIds: itemIds}).then(
            (successResponse) => {
                item.isRemoved = !item.isRemoved;
                this.hideError();
        }, (errorResponse) => {
                const errorVerb = item.isRemoved ? 'restore' : 'remove';
                this.showErrorMessage(`There was an error trying to ${errorVerb} this item. If this problem ` +
                    `persists, please contact a site administrator.`);
            });
    }

    updatePaginationStartingIndex(startingIndex) {
        this.startingIndex = startingIndex;
    }

}

export default RelatedListFieldController;


// WEBPACK FOOTER //
// ./app/common/form-fields/related-list-field/related-list-field-controller.js